import ModalFooter from "@/modules/common/components/modals/modal-footer";
import useScreenSize from "@/modules/common/hooks/device-detection.hook";
import { muiTheme } from "@/styles/theme";
import { Box } from "@mui/material";
import Grid from "@mui/material/GridLegacy";

const FormFooter = ({
  isLoadingSubmition,
  handleClose,
  confirmText,
  disabled,
}: {
  isLoadingSubmition: boolean;
  handleClose: () => void;
  confirmText: string;
  disabled?: boolean;
}) => {
  const screen = useScreenSize();
  return (
    <>
      <Grid
        sx={{
          marginTop: "3rem",
        }}
        item
        mobile={12}
      >
        {screen.isMobile ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              position: "fixed",
              bottom: "0",
              left: "0",
              right: "0",
              gap: 1,
              maxWidth: "100vw",
              backgroundColor:
                muiTheme.colorSchemes.light.palette.background.blue1,
              padding: 2,
              zIndex: 9,
            }}
          >
            <ModalFooter
              isSubmitting={isLoadingSubmition}
              confirmText={confirmText}
              handleClose={handleClose}
              disabledConfirmButton={disabled}
              confirmTestId="edit-status-save"
              cancelTestId="edit-status-cancel"
            />
          </Box>
        ) : (
          <ModalFooter
            isSubmitting={isLoadingSubmition}
            confirmText={confirmText}
            handleClose={handleClose}
            disabledConfirmButton={disabled}
            confirmTestId="edit-status-save"
            cancelTestId="edit-status-cancel"
          />
        )}
      </Grid>
    </>
  );
};

export default FormFooter;
